import React from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import BonusOffer from 'core/modules/BonusOffers/components/BonusOffer';
import List from 'core/modules/Partials/List/List';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';

import { useGetBonusOffers } from 'core/modules/BonusOffers/hooks';
import { selectSiteUrl } from 'core/selectors/app';
import { useTriggerBonusOffers300x250GAEvents } from './hooks';
import { selectBonusOffers } from './selectors';

import config from './configs';

import './BonusOffers300x250.scss';

function BonusOffers300x250() {
  const bonusOffers = useSelector(selectBonusOffers);
  const siteUrl = useSelector(selectSiteUrl);
  const {
    title, useCarousel, minNumberOfBonusOffersToRenderSection, shouldShowTitleLink, carousel,
  } = config;

  const shouldRenderSection = bonusOffers.length >= minNumberOfBonusOffersToRenderSection;

  useGetBonusOffers();
  useTriggerBonusOffers300x250GAEvents(shouldRenderSection);

  const renderBonusOffers = () => (bonusOffers.map(offer => (
    <BonusOffer className="mn_offer mn_bonusMerchantOffer300x250" key={offer.bonusId} {...offer} config={config} />
  )));

  if (isEmpty(bonusOffers) || !shouldRenderSection) {
    return null;
  }

  return (
    <div className="mn_bonusMerchantOffers300x250">
      <ContentWrap mobile tablet l xl>
        <SectionTitle title={title}>
          { shouldShowTitleLink && <a className="mn_viewAllLink" href={`${siteUrl}/foryou____.htm`}>See all</a> }
        </SectionTitle>
        <div className="mn_bonusOffersList">
          <List shouldUseCarousel={useCarousel} options={carousel}>
            {renderBonusOffers()}
          </List>
        </div>
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><BonusOffers300x250 {...props} /></ComponentErrorBoundary>;
